import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useApp } from "@/context/AppContext";
import { RequestProject } from "@/pages/client/RequestProject";
import { Anfragen } from "@/pages/team/Anfragen";

/**
 * Eine Adresse, zwei Sichten (wie `/assistent`): Ein Kundenkonto stellt hier
 * seine Projektanfrage, das Team sieht die Pipeline der Interessenten samt
 * Eingang der Projektanfragen (seit dem 11.09.2026). `?ansicht=angebote`
 * zeigt das Angebotsarchiv (seit dem Rundgang vom 12.09.2026 hier statt als
 * eigener Menüpunkt).
 */
const suchSchema = z.object({
	ansicht: z.enum(["pipeline", "angebote", "kalkulator"]).optional(),
});

export const Route = createFileRoute("/_angemeldet/anfragen")({
	validateSearch: suchSchema,
	component: AnfragenSeite,
});

function AnfragenSeite() {
	const { role } = useApp();
	const { ansicht } = Route.useSearch();
	const navigate = useNavigate();
	if (role !== "mitarbeiter") return <RequestProject />;
	return (
		<Anfragen
			ansicht={ansicht ?? "pipeline"}
			onAnsicht={(neu) => {
				void navigate({
					to: "/anfragen",
					search: neu === "pipeline" ? {} : { ansicht: neu },
					replace: true,
				});
			}}
		/>
	);
}
